import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { IconPlus, IconX } from '@tabler/icons-react'
import { v4 as uuidv4 } from 'uuid';
import { CustomSelectCustomOptionOption, SelectCustomLoadingSearching, loadOptionProps, loadOptionReturnProps, loadSelectedOptionProps, loadSelectedOptionReturnProps } from '../../../../components/input_loading_searching';
import { Product, ProductCategory, ProductImage, Store, Warehouse, RackKeys, employee, Rack, } from '../../../../../../../types';
import useFormValidatonCustom, { validationObject } from '../../../../../../../hooks/form_validation_hook';
import { useRESTapi } from '../../../../../../../hooks/rest_API';
import { RootState } from '../../../../../../../redux/store';
import { useParams } from 'react-router-dom';
import { AdminModal, AdminModalContent, AdminModalFooter, AdminModalHeader, AdminModalMiddle, AdminModalTitle } from '@/src/pages/admin/components/modal';
import { Input } from '@/src/components/ui/input';
import { Switch } from '@/src/components/ui/switch';
import { Button } from '@/src/components/ui/button';




type RackOverview = Rack

type imageIds = string[]



export function AddRackModal(
    {
        show,
        closeModal,
        id,
        updateUi,
        mode,
        setShow
    }:
        {
            show: boolean,
            setShow: (show: boolean) => any,
            closeModal: () => void,
            id?: string,
            updateUi: () => void,
            mode: 'add' | 'edit',
        }
) {

    const { warehouseId, storeId } = useParams()


    const validationObject = {
        [RackKeys.I03_Warehouse_Rackname]: {
            message: '',
            validation: [
                (value) => {

                    if (!value) {
                        return 'required'
                    }
                    return true
                }
            ]
        },


    } satisfies validationObject

    const api = useRESTapi();
    const employee = useSelector((state: RootState) => state.employee)
    const [formData, setFormData] = useState<RackOverview>({
        I03_I01_Warehouse_id: '',
        I03_I02_Warehouse_store_id: '',
        I03_is_active: 1,
        I03_M15_created_by: '',
        I03_Warehouse_Rackname: ''
    })
    const [isLoading, setIsLoading] = useState(false)
    const { performAllValidation, performValidationOf, errorData, setErrorData } = useFormValidatonCustom<Rack>({
        validationObject: validationObject
    })
    const [loading, set_loading] = useState(false)



    function handleChangeInput(e: React.ChangeEvent<HTMLInputElement>) {

        let formdata: Rack;

        switch (e.target.name) {


            default:
                formdata = {
                    ...formData,
                    [e.target.name]: e.target.value
                }
                break;
        }




        setFormData(formdata)
        performValidationOf(e.target.name, formdata)
        console.log(formdata)

    }

    async function add_rack() {

        setIsLoading(true)
        // formData.M11_created_by = employee.M15_Employee_id!
        if (performAllValidation(formData) === true) {

            try {

                const formDataReal = new FormData();
                formData.I03_M15_created_by = employee.employeeData.M15_Employee_id!
                formData.I03_I01_Warehouse_id = warehouseId!
                formData.I03_I02_Warehouse_store_id = storeId!
                console.log(formData)
                Object.entries(formData).map(
                    data => {


                        formDataReal.append(data[0], String(data[1]))

                    }
                )

                // const anyFormData  = formData as any

                // for (const key in formData) {
                //     formDataReal.append(key, String(anyFormData[key]))
                // }

                const res = await api.post<{ success: boolean, data: Store, errors: any, message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/warehouse_rack`,
                    body: formDataReal,
                    mode: 'admin'
                })

                if (res.data.success === true) {

                    updateUi();
                    alert(res.data?.message || 'added rack')
                    closeModal()
                    
                } else {
                    alert(res.data?.message || 'something went wrong')
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }
                    
                }
            } catch (error) {
                console.log(error)
            }
        }
        setIsLoading(false)

    }
    async function edit_store() {

        setIsLoading(true)
        // formData.M11_created_by = employee.M15_Employee_id!
        if (performAllValidation(formData) === true) {

            try {

                const formDataReal = new FormData();
                formData.I03_M15_created_by = employee.employeeData.M15_Employee_id!
                formData.I03_I01_Warehouse_id = warehouseId!
                formData.I03_I02_Warehouse_store_id = storeId!
                formDataReal.append('_method', "PUT")

                Object.entries(formData).map(
                    data => {

                        formDataReal.append(data[0], String(data[1]))

                    }
                )



                const res = await api.post<{ success: boolean, data: Store, errors: any, message: string }>({
                    url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/warehouse_rack/${id}`,
                    body: formDataReal,
                    mode: 'admin'
                })

                if (res.data.success === true) {
                                        
                    updateUi();
                    alert(res.data?.message || 'updated store')
                    setShow(false)

                    
                } else {
                    alert(res.data?.message || 'something went wrong')
                    if (res.data.errors) {

                        const errs = res.data.errors;
                        const errData: any = {}

                        for (const key in errs) {
                            errData[key] = errs[key][0]
                        }

                        setErrorData(errData)

                    }

                }
            } catch (error) {
                console.log(error)
            }
        }
        setIsLoading(false)

    }


    const fetch_selected_Employee: (props: loadSelectedOptionProps) => Promise<loadSelectedOptionReturnProps<employee & CustomSelectCustomOptionOption>> = async (props: loadSelectedOptionProps) => {
        if (props.value) {
            const res = await api.get<{ success: boolean, data: employee, errors: any, message: string }>({
                url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/Employees/${props.value}`,
                mode: 'admin'
            })

            if (res.data.success === false) {

                alert(res.data?.message || 'something went wrong')
                return {
                    options: null
                }
            } else {

                // alert(res.data.message)
                return {
                    options: {
                        ...res.data.data,
                        name: res.data.data.M15_Name,
                        value: res.data.data.M15_Employee_id,

                    } as (employee & CustomSelectCustomOptionOption)
                }
            }
        }
        return {
            options: null
        }
    }


    const load_product = async () => {

        const res = await api.get<{ success: boolean, data: Rack, message?: string }>({
            url: `${process.env.REACT_APP_BACKEND_URL_ADMIN!}/warehouse_rack/${id}`,
            mode: 'admin'
        })
        if (res.data.success === true) {
            // images_url.images = res.data.data.images ? res.data.data.images : []

            // res.data.data.M11_ProductImages = []
            setFormData(res.data.data)
        } else {
            throw res.data
        }


    }




    useEffect(
        () => {

            const initListSetup = () => {
                set_loading(true)
                setFormData({
                    I03_I01_Warehouse_id: '',
                    I03_I02_Warehouse_store_id: '',
                    I03_is_active: 1,
                    I03_M15_created_by: '',
                    I03_Warehouse_Rackname: ''
                })
                setErrorData({})
                set_loading(false)

            }
            const initEditSetup = () => {
                set_loading(true)

                Promise.all(
                    [load_product()]
                ).then(
                    () => {
                        set_loading(false)

                    }
                ).catch(
                    (err) => {
                        set_loading(false)

                    }
                )

            }

            if (mode === 'add' && show === true) {
                setErrorData({})
                initListSetup()
            } else if (mode === 'edit' && show === true) {
                initEditSetup()
                // initListSetup()

            } else {
                set_loading(true)
            }


        }, [show]
    )



    return (

        <AdminModal show={show} setShow={setShow} >
            <AdminModalContent>
                <AdminModalHeader>
                    <AdminModalTitle>{mode === 'add' ? 'Add Rack' : 'Edit Rack'}</AdminModalTitle>
                </AdminModalHeader>
                <AdminModalMiddle>
                    <Input disabled={loading || isLoading} value={formData.I03_Warehouse_Rackname} onChange={handleChangeInput} type="text" name={RackKeys.I03_Warehouse_Rackname} placeholder='rack name' />
                    <div className=' text-red-500'>{errorData.I03_Warehouse_Rackname ? errorData.I03_Warehouse_Rackname : null}</div>
                    <div className=' min-h-2'></div>

                    <div className=' flex gap-1'>
                        {/* <Input checked={formData.I03_is_active === 1 ? true : false} type="checkbox" name={RackKeys.I03_is_active} onChange={handleChangeInput} /> */}
                        <Switch disabled={loading || isLoading} checked={formData.I03_is_active === 1 ? true : false} name={RackKeys.I03_is_active} onCheckedChange={(checked) => handleChangeInput({
                            target: {
                                name: RackKeys.I03_is_active,
                                value: checked ? 1 : '0',
                                checked: checked
                            }
                        } as React.ChangeEvent<HTMLInputElement>)} />
                        <div>is active</div>
                    </div>

                    <AdminModalFooter>
                        <Button variant={'outline'} disabled={isLoading} onClick={closeModal}  >Cancel</Button>
                        {
                            mode === 'add' ?
                                <Button disabled={isLoading||loading} onClick={add_rack}  >{isLoading ? 'adding...' : 'Add'}</Button>
                                :
                                <Button disabled={isLoading||loading} onClick={edit_store}  >{isLoading ? 'editing...' : 'edit'}</Button>}

                    </AdminModalFooter>
                </AdminModalMiddle>
            </AdminModalContent>
        </AdminModal>
    )

}
